<template>
  <div>
    <h1 class="text-2xl mb-6">Google Trends Notifications</h1>
    <chatGroupTable></chatGroupTable>
    <v-row justify="center" class="mt-12 mb-12">
      <v-btn class="primary" @click="dialog = true"
        >Demande de nouveau canal</v-btn
      >
    </v-row>
    <v-row>
      <v-col>
        <keywords-table></keywords-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog">
      <ChatGroupCreation
        @close-dialog="dialog = false"
        @saved="showSuccessMessage = true"
      ></ChatGroupCreation>
    </v-dialog>
    <v-snackbar v-model="showSuccessMessage" color="success" timeout="3000" top>
      Demande envoyée avec succès
    </v-snackbar>
  </div>
</template>
<script>
import ChatGroupCreation from "@/components/gtrends/cards/chatGroupCreation.vue";
import chatGroupTable from "@/components/gtrends/tables/chatgroupTable.vue";
import keywordsTable from "@/components/gtrends/tables/keywordsTable.vue";
export default {
  name: "gTrendsNotifications",
  components: {
    chatGroupTable,
    ChatGroupCreation,
    keywordsTable,
  },
  data() {
    return {
      dialog: false,
      showSuccessMessage: false,
    };
  },
};
</script>
<style></style>
